function request(actionType) {
  return {
    type: actionType,
  };
}

function success(actionType, response) {
  return {
    type: actionType,
    payload: response,
  };
}

function failure(actionType, error) {
  return {
    type: actionType,
    payload: error,
  };
}

const PAY_ROLL = {
  GENERATE_PAY_ROLL_REQUEST: 'GENERATE_PAY_ROLL_REQUEST',
  GENERATE_PAY_ROLL_SUCCESS: 'GENERATE_PAY_ROLL_SUCCESS',
  GENERATE_PAY_ROLL_FAILURE: 'GENERATE_PAY_ROLL_FAILURE',

  CREATE_PAY_ROLL_REQUEST: 'CREATE_PAY_ROLL_REQUEST',
  CREATE_PAY_ROLL_SUCCESS: 'CREATE_PAY_ROLL_SUCCESS',
  CREATE_PAY_ROLL_FAILURE: 'CREATE_PAY_ROLL_FAILURE',

  CREATE_MANUAL_PAY_ROLL_REQUEST: 'CREATE_MANUAL_PAY_ROLL_REQUEST',
  CREATE_MANUAL_PAY_ROLL_SUCCESS: 'CREATE_MANUAL_PAY_ROLL_SUCCESS',
  CREATE_MANUAL_PAY_ROLL_FAILURE: 'CREATE_MANUAL_PAY_ROLL_FAILURE',

  UPDATE_PAY_ROLL_REQUEST: 'UPDATE_PAY_ROLL_REQUEST',
  UPDATE_PAY_ROLL_SUCCESS: 'UPDATE_PAY_ROLL_SUCCESS',
  UPDATE_PAY_ROLL_FAILURE: 'UPDATE_PAY_ROLL_FAILURE',

  GET_PAY_ROLL_BY_ID_REQUEST: 'GET_PAY_ROLL_BY_ID_REQUEST',
  GET_PAY_ROLL_BY_ID_SUCCESS: 'GET_PAY_ROLL_BY_ID_SUCCESS',
  GET_PAY_ROLL_BY_ID_FAILURE: 'GET_ALL_PAY_ROLL_FAILURE',

  DELETE_MANUAL_PAY_ROLL_REQUEST: 'DELETE_MANUAL_PAY_ROLL_REQUEST',
  DELETE_MANUAL_PAY_ROLL_SUCCESS: 'DELETE_MANUAL_PAY_ROLL_SUCCESS',
  DELETE_MANUAL_PAY_ROLL_FAILURE: 'DELETE_MANUAL_PAY_ROLL_FAILURE',

  DELETE_PAY_ROLL_REQUEST: 'DELETE_PAY_ROLL_REQUEST',
  DELETE_PAY_ROLL_SUCCESS: 'DELETE_PAY_ROLL_SUCCESS',
  DELETE_PAY_ROLL_FAILURE: 'DELETE_PAY_ROLL_FAILURE',

  GET_PAY_ROLL_REQUEST: 'GET_PAY_ROLL_REQUEST',
  GET_PAY_ROLL_SUCCESS: 'GET_PAY_ROLL_SUCCESS',
  GET_PAY_ROLL_FAILURE: 'GET_PAY_ROLL_FAILURE',
};

const INBOX = {
  GET_INBOX_CHATS_REQUEST: 'GET_INBOX_CHATS_REQUEST',
  GET_INBOX_CHATS_SUCCESS: 'GET_INBOX_CHATS_SUCCESS',
  GET_INBOX_CHATS_FAILURE: 'GET_INBOX_CHATS_FAILURE',

  SET_SELECTED_CHAT_OBJECT: 'SET_SELECTED_CHAT_OBJECT',
  SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
  SET_FILTER_BY: 'SET_FILTER_BY',
  SET_PERSON_FILTER: 'SET_PERSON_FILTER',
  SET_FILTER_DATE: 'SET_FILTER_DATE',
}

export { request, success, failure, PAY_ROLL, INBOX };
